import {
  ETextParamType_AvatarFileName,
  ETextParamType_PlayerMoveEnable,
  ETextParamType_SceneItem,
  ETextParamType_WarpPlayer,
  ETextParamType_StopItem,
  ETextParamType_PlayEmote,
  ETextParamType_IsLoading,
  ETextParamType_SubSceneItem,
  ETextParamType_GlobalFileName,
  ETextParamType_WalkTo
} from './logics/const';
import {
  hel_player_SetPriority,
  hel_remove_emoji,
  hel_webcamtracking_setposedata,
  hel_webcamtracking_sethanddata
} from './logics/misc';
import {hel_setText} from './logics/moduleCaller';
import {hel_textchat_send_message} from './logics/shared';
import {hel_skyway_send_chat_text} from './logics/skyway';

Object.assign(globalThis, {
  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * heliodor_frontから呼出があるため、global関数としておいておく
   * @param Flag
   */
  hel_player_SetMoveEnable: (Flag: boolean) => {
    hel_setText(ETextParamType_PlayerMoveEnable, Flag ? '1' : '0');
  },

  // For Send chat message by ENTER key when IME is off.
  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_front.jsにて参照
   * heliodor_frontから呼出があるため、global関数としておいておく
   * @param event
   */
  hel_send_chat_message_enterkey: (event: KeyboardEvent) => {
    if (event.keyCode === 13 && !event.isComposing) {
      hel_skyway_send_chat_text(); // heliodor_skyway.js
      hel_textchat_send_message();

      event.stopPropagation();
      event.preventDefault();
    }
  },

  // Item
  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * heliodor_front.jsから参照あるためglobal関数としておいておく
   * @param ItemName
   * @param Index
   */
  hel_scene_PlayItem: (ItemName: string, Index: number) => {
    hel_setText(ETextParamType_SceneItem, 'Play,' + ItemName + ',' + Index);
  },

  /**
   * @remarks
   * @param ItemName
   */
  hel_scene_StopItem: (ItemName: string) => {
    hel_setText(ETextParamType_StopItem, ItemName);
  },

  /**
   * @param EmoteIndex
   */
  hel_player_PlayEmote: (EmoteIndex: string) => {
    hel_setText(ETextParamType_PlayEmote, EmoteIndex);
  },

  /**
   * @remarks
   * @param ItemName
   * @param MaterialName
   * @param FilePath
   */
  hel_scene_ReplaceTexture: (ItemName: string, MaterialName: string, FilePath: string) => {
    hel_setText(
      ETextParamType_SceneItem,
      'ReplaceTexture,' + ItemName + ',' + MaterialName + ',' + FilePath
    );
  },

  /**
   * @remarks
   * @param ItemName
   * @param MaterialName
   * @param FilePath
   */
  hel_sub_scene_ReplaceTexture: (ItemName: string, MaterialName: string, FilePath: string) => {
    hel_setText(
      ETextParamType_SubSceneItem,
      'ReplaceTexture,' + ItemName + ',' + MaterialName + ',' + FilePath
    );
  },

  /**
   * @remarks
   * @param ItemName
   * @param MaterialName
   * @param CanvasID
   */
  hel_scene_ReplaceTextureByHTMLCanvas: (
    ItemName: string,
    MaterialName: string,
    CanvasID: string
  ) => {
    hel_setText(
      ETextParamType_SceneItem,
      'ReplaceTextureByHTMLCanvas,' + ItemName + ',' + MaterialName + ',' + CanvasID
    );
  },

  /**
   * @remarks
   * @param ItemName
   * @param NodeName
   * @param Show
   */
  hel_scene_SetEnableCollider: (ItemName: string, NodeName: string, Show: string) => {
    hel_setText(
      ETextParamType_SceneItem,
      'SetEnableCollider,' + ItemName + ',' + NodeName + ',' + Show
    );
  },

  // Player
  /**
   * @remarks
   * JRWorld_web->heliodor_front.jsにて参照
   * frontから呼出があるため、global関数としておいておく
   * @param X
   * @param Y
   * @param Z
   * @param Angle
   */
  hel_player_Warp: (X: number, Y: number, Z: number, Angle: number) => {
    hel_setText(ETextParamType_WarpPlayer, '' + X + ',' + Y + ',' + Z + ',' + Angle);
  },

  hel_player_SetPriority,

  /**
   * @remarks
   * XRWorldIngame->heliodor_front.jsにて参照
   * XRWorldIngame->heliodor_skyway.jsにて参照
   * XRWorldIngame->heliodor_skyway_xrw.jsにて参照
   * heliodor_front.jsから参照あるためglobal関数としておいておく
   */
  hel_remove_emoji,

  /**
   * @remarks
   * アバターパッケージJSONをHELIDORに設定するための関数
   *
   * @param avatarFileName
   */
  hel_setAvatarFileName: (avatarFileName: string) => {
    hel_setText(ETextParamType_AvatarFileName, avatarFileName);
  },

  /**
   * @remarks
   * アバターパッケージJSONをHELIDORに設定するための関数
   *
   */
  hel_isLoading: (): boolean => {
    return hel_setText(ETextParamType_IsLoading, '') !== 0;
  },

  hel_setGlobalComponentFileName: (globalFileName: string) => {
    hel_setText(ETextParamType_GlobalFileName, globalFileName);
  },

  // WebCamトラッキング
  hel_webcamtracking_setposedata,

  hel_webcamtracking_sethanddata,

  // プレイヤーを指定座標まで強制的に移動させる
  hel_walkTo: (X: number, Y: number, Z: number): number => {
    return hel_setText(ETextParamType_WalkTo, '' + X + ',' + Y + ',' + Z);
  }
});
